import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'navtop',
  templateUrl: './navtop.component.html',
  styleUrls: ['./navtop.component.scss'],
})
export class NavtopComponent implements OnInit {
  @Input() title?: String;
  constructor() {   }  

  ngOnInit() {}

}
